import { IconButton, TooltipDelay, TooltipHost } from '@fluentui/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../../../common/components/modals/ConfirmationModal';
import { notify } from '../../../common/utils/notification';
import { useDeleteToken } from '../api/useDeleteToken';

export const DeleteTokenBtn = ({ clientId }: { clientId: string }) => {
  const { t } = useTranslation();
  const [isDeleteConfirmationVisible, setIsDeleteConfirmationVisible] = useState(false);
  const { mutate, isLoading: isDeleting } = useDeleteToken();

  const handleDeleteToken = () => {
    mutate(clientId, {
      onError: () => {
        notify.error(t('common:tokenGenerationError'));
      }
    });
  };

  return (
    <>
      <TooltipHost
        content={t('common:removeSecretBtnText')}
        id="removeToken"
        delay={TooltipDelay.zero}
      >
        <IconButton
          iconProps={{
            iconName: 'Delete',
            styles: { root: { color: 'var(--theme-palette-error-default)'  } },
          }}
          title={t('common:removeSecretBtnText')}
          ariaLabel={t('common:removeSecretBtnText')}
          onClick={() => {
            setIsDeleteConfirmationVisible(true);
          }}
        />
      </TooltipHost>

      {isDeleteConfirmationVisible && (
        <ConfirmationModal
          confirmBtnText={t('common:remove')}
          isLoading={isDeleting}
          onCancel={() => setIsDeleteConfirmationVisible(false)}
          onSuccess={() => {
            handleDeleteToken();
            setIsDeleteConfirmationVisible(false);
          }}
          dialogContentProps={{
            title: t('common:removeSecretBtnText'),
            subText: t('common:removeSecretSubText'),
          }}
        />
      )}
    </>
  );
};